<template>
  <slide from="bottom" :show="show">
    <select-area @on-cancel="cancel" @on-confirm="confirm"/>
  </slide>
</template>

<script>
import SelectArea from '@/components/select-area'
import Slide from '@/components/slide'
const handler = (e) => {
  e.preventDefault()
}
export default {
  components: {
    SelectArea,
    Slide
  },
  data () {
    return {
      show: false
    }
  },
  methods: {
    cancel: function(){
      this.$emit('on-cancel')
    },
    confirm: function(data){
      this.$emit('on-confirm', data)
    }
  },
  watch:{
    show:function(val){
      if(val){
        this.$el.addEventListener('touchmove', handler, false)
      }else{
        this.$el.removeEventListener('touchmove', handler, false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?472acedd